import { render } from "./MobileCard.vue?vue&type=template&id=273096b4&scoped=true"
import script from "./MobileCard.vue?vue&type=script&lang=js"
export * from "./MobileCard.vue?vue&type=script&lang=js"

import "./MobileCard.vue?vue&type=style&index=0&id=273096b4&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273096b4"]])

export default __exports__